export default "__VITE_ASSET__DFHtoSjt__"